import { Carrier, CarrierType, CheckoutPlan } from "../Onboarding";
import { MockCheckoutPlan } from "./MockCheckoutPlan";

export class MockCarrier implements Carrier {
  type = CarrierType.CELCOM;
  plan: CheckoutPlan = new MockCheckoutPlan();
}
